import { createSelector } from '@ngrx/store';

import { getCartLocationNo } from '../../../cart/selectors';
import { getOrderTypes } from '../../../orderTypes/selectors';

export const getOrderTypesForCartsLocation = createSelector(getCartLocationNo, getOrderTypes, (locationNo, orderTypes) => {
    if (!locationNo || orderTypes.isDownloading === true) return null;

    return orderTypes.data || null;
});
